import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  Avatar,
  IconButton,
  Divider,
  Stack,
  useMediaQuery,
  useTheme,
  Button
} from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import RockkPayLogo from '../Assets/Rockkpay/RockkpayLogo.png';


const menuItems = [
  { label: 'Home', id: 'Home-Section-One' },
  { label: 'About', id: 'Home-Section-Two' },
  { label: 'Services', id: 'Home-Section-Three' },
  { label: 'Features', id: 'Home-Section-Four' },
  { label: 'Contact', id: 'Home-Section-Five' },
];
const footerLinks = [
  {
    title: "Company",
    links: [
      { name: "Home", id: "Home-Section-One" },
      { name: "About", id: "Home-Section-Two" },
      { name: "Services", id: "Home-Section-Three" },
      { name: "Features", id: "Home-Section-Four" },
      { name: "Contact", id: "Home-Section-Five" }
    ]
  },
 
  {
    title: "Support",
    links: [
      { name: "Help Center",id: "Home-Section-Five"  },
      { name: "FAQs", id: 'faq' },
      // { name: "User Guides", url: "/guides" },
     
    ]
  },
  {
    title: "Legal",
    links: [
      { name: "Terms of Service",url: "/Rterms" },
      { name: "Privacy Policy",url: "/privacyandpolicy"  },
      { name: "Refund And Cancellation",url: "/refundandcancelpolicy"  },

      
    ]
  }
];

const FooterTwo = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <Box sx={{ position: "relative" }}>
      {/* Back to top button */}
      <Box 
        sx={{ 
          position: "absolute", 
          top: -25, 
          left: "50%", 
          transform: "translateX(-50%)",
          zIndex: 10
        }}
      >
        <IconButton 
          onClick={scrollToTop}
          sx={{
            bgcolor: "white",
            boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
            width: 50,
            height: 50,
            "&:hover": {
              bgcolor: "white",
              transform: "translateY(-3px)",
              boxShadow: "0 8px 25px rgba(0,0,0,0.2)"
            },
            transition: "all 0.3s"
          }}
        >
          <KeyboardArrowUpIcon color="primary" />
        </IconButton>
      </Box>

      {/* Newsletter Section */}
      <Box sx={{ 
        background: "linear-gradient(90deg, #4568dc 0%, #b06ab3 100%)",
        py: { xs: 6, md: 8 },
        color: "white"
      }}>
        <Container>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={6}>
              <Typography variant="h4" fontWeight={700} gutterBottom>
                Stay Connected
              </Typography>
              <Typography variant="body1" sx={{ mb: 2, opacity: 0.9 }}>
                Subscribe to our newsletter for updates, promotions, and payment tips.
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box 
                component="form" 
                sx={{ 
                  display: "flex", 
                  flexDirection: { xs: "column", sm: "row" },
                  gap: 1 
                }}
                noValidate
              >
                <Box 
                  component="input" 
                  placeholder="Your email address" 
                  sx={{
                    flex: 1,
                    border: "none",
                    borderRadius: 2,
                    py: 1.5,
                    px: 2,
                    outline: "none",
                    fontSize: "1rem",
                    width: { xs: "auto", sm: "auto" }
                  }}
                />
                <Button 
                  variant="contained" 
                  sx={{ 
                    bgcolor: "#fff", 
                    color: "#4568dc", 
                    fontWeight: 600,
                    py: 1.5,
                    "&:hover": { 
                      bgcolor: "#f0f0f0",
                    },
                    width: { xs: "100%", sm: "auto" }
                  }}
                >
                  Subscribe
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Main Footer */}
      <Box 
        sx={{ 
          bgcolor: "#111827", 
          color: "#fff",
          pt: 8,
          pb: 4,
          backgroundImage: "radial-gradient(circle at 50% 0%, rgba(69, 104, 220, 0.1) 0%, rgba(176, 106, 179, 0.05) 70%)"
        }}
      >
        <Container>
          <Grid container spacing={isMobile ? 4 : 6}>
            {/* Logo and About Section */}
            <Grid item xs={12} md={4}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
                <Avatar
                  src={RockkPayLogo}
                  alt="RockkPay Logo"
                  sx={{
                    width: 50,
                    height: 50,
                    border: '2px solid #60a5fa',
                    boxShadow: '0 0 10px rgba(96, 165, 250, 0.6)',
                    mr: 2
                  }}
                />
                <Typography 
                  variant="h5" 
                  fontWeight={700}
                  sx={{ 
                    background: "linear-gradient(90deg, #4568dc 0%, #b06ab3 100%)",
                    backgroundClip: "text",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent" 
                  }}
                >
                  RockkPay
                </Typography>
              </Box>
              
              <Typography variant="body2" color="gray.400" sx={{ mb: 3, maxWidth: 350, color: "#cbd5e1" }}>
                Secure, fast, and reliable payment solutions for individuals and businesses worldwide. Transforming how the world manages money.
              </Typography>
              
              <Box sx={{ mb: 4 }}>
                <Stack spacing={1.5}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <LocationOnIcon sx={{ color: "#60a5fa", fontSize: 20 }} />
                    <Typography variant="body2" sx={{ color: "#cbd5e1" }}>Edsom Fintech Private Limited, Second Floor,
Golden Empire, Baner Pune - 411045
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    {/* <PhoneIcon sx={{ color: "#60a5fa", fontSize: 20 }} />
                    <Typography variant="body2" sx={{ color: "#cbd5e1" }}>
                      +91 9999999999
                    </Typography> */}
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <EmailIcon sx={{ color: "#60a5fa", fontSize: 20 }} />
                    <Typography variant="body2" sx={{ color: "#cbd5e1" }}>
                      rockkpay@gmail.com
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <PhoneIcon sx={{ color: "#60a5fa", fontSize: 20 }} />
                    <Typography variant="body2" sx={{ color: "#cbd5e1" }}>
                    +91 8484934745
                    </Typography>
                  </Box>
                </Stack>
              </Box>
              
              <Box>
                <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                  Follow Us
                </Typography>
                <Stack direction="row" spacing={1}>
                  <IconButton 
                    size="small" 
                    sx={{ 
                      color: "white", 
                      bgcolor: "rgba(96, 165, 250, 0.2)",
                      "&:hover": { bgcolor: "#60a5fa", transform: "translateY(-3px)" },
                      transition: "all 0.2s"
                    }}
                  >
                    <FacebookIcon fontSize="small" />
                  </IconButton>
                  <IconButton 
                    size="small" 
                    sx={{ 
                      color: "white", 
                      bgcolor: "rgba(96, 165, 250, 0.2)",
                      "&:hover": { bgcolor: "#60a5fa", transform: "translateY(-3px)" },
                      transition: "all 0.2s"
                    }}
                  >
                    <TwitterIcon fontSize="small" />
                  </IconButton>
                  <IconButton 
                    size="small" 
                    sx={{ 
                      color: "white", 
                      bgcolor: "rgba(96, 165, 250, 0.2)",
                      "&:hover": { bgcolor: "#60a5fa", transform: "translateY(-3px)" },
                      transition: "all 0.2s"
                    }}
                  >
                    <InstagramIcon fontSize="small" />
                  </IconButton>
                  <IconButton 
                    size="small" 
                    sx={{ 
                      color: "white", 
                      bgcolor: "rgba(96, 165, 250, 0.2)",
                      "&:hover": { bgcolor: "#60a5fa", transform: "translateY(-3px)" },
                      transition: "all 0.2s"
                    }}
                  >
                    <LinkedInIcon fontSize="small" />
                  </IconButton>
                  <IconButton 
                    size="small" 
                    sx={{ 
                      color: "white", 
                      bgcolor: "rgba(96, 165, 250, 0.2)",
                      "&:hover": { bgcolor: "#60a5fa", transform: "translateY(-3px)" },
                      transition: "all 0.2s"
                    }}
                  >
                    <YouTubeIcon fontSize="small" />
                  </IconButton>
                </Stack>
              </Box>
            </Grid>
            
            {/* Footer Links */}
            {/* Footer Links */}
<Grid item xs={12} md={8}>
  <Grid container spacing={isTablet ? 3 : 6}>
    {footerLinks.map((category, index) => (
      <Grid item xs={6} sm={3} key={index}>
        <Typography variant="subtitle2" fontWeight={600} gutterBottom>
          {category.title}
        </Typography>
        <Stack spacing={1.5}>
          {category.links.map((link, idx) => (
            <Link 
              key={idx} 
              href={link.url ? link.url : `#${link.id}`} 
              underline="none" 
              color="#cbd5e1"
              onClick={(e) => {
                if (link.id) {
                  e.preventDefault();
                  const element = document.getElementById(link.id);
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                  }
                }
              }}
              sx={{ 
                "&:hover": { 
                  color: "#60a5fa",
                  pl: 0.5
                },
                transition: "all 0.2s",
                fontSize: "0.9rem"
              }}
            >
              {link.name}
            </Link>
          ))}
        </Stack>
      </Grid>
    ))}
  </Grid>
</Grid>
          </Grid>
          
          <Divider sx={{ borderColor: "rgba(255,255,255,0.1)", my: 4 }} />
          
          {/* Bottom Footer */}
          <Grid 
            container 
            justifyContent="space-between" 
            alignItems="center"
            spacing={2}
            sx={{ color: "#94a3b8" }}
          >
            <Grid item xs={12} md={6}>
              <Typography variant="body2">
                © {new Date().getFullYear()} RockkPay. All Rights Reserved.
              </Typography>
            </Grid>
            
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default FooterTwo;